export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS';
export const LOG_OUT = 'LOG_OUT';
export const LOAD_TESLA_AUTH_STATUS_SUCCESS = 'LOAD_TESLA_AUTH_STATUS_SUCCESS';
export const LOAD_TESLA_VEHICLES_SUCCESS = 'LOAD_TESLA_VEHICLES_SUCCESS';
export const LOAD_DEPARTURE_SCHEDULES_SUCCESS = 'LOAD_DEPARTURE_SCHEDULES_SUCCESS';
export const CREATE_DEPARTURE_SCHEDULE_SUCCESS = 'CREATE_DEPARTURE_SCHEDULE_SUCCESS';
export const UPDATE_DEPARTURE_SCHEDULE_SUCCESS = 'UPDATE_DEPARTURE_SCHEDULE_SUCCESS';
export const DELETE_DEPARTURE_SCHEDULE_SUCCESS = 'DELETE_DEPARTURE_SCHEDULE_SUCCESS';
export const LOAD_SUBSCRIPTIONS_SUCCESS = 'LOAD_SUBSCRIPTIONS_SUCCESS';
export const CREATE_SUBSCRIPTIONS_SUCCESS = 'CREATE_SUBSCRIPTIONS_SUCCESS';
export const UPDATE_CARD_DETAILS_SUCCESS = 'UPDATE_CARD_DETAILS_SUCCESS';
export const ADD_PRODUCTS_SUCCESS = 'ADD_PRODUCTS_SUCCESS';
export const REMOVE_PRODUCTS_SUCCESS = 'REMOVE_PRODUCTS_SUCCESS';
export const CANCEL_SUBSCRIPTIONS_SUCCESS = 'CANCEL_SUBSCRIPTIONS_SUCCESS';
export const REACTIVATE_SUBSCRIPTIONS_SUCCESS = 'REACTIVATE_SUBSCRIPTIONS_SUCCESS';
export const LOAD_PREFERENCES_SUCCESS = 'LOAD_PREFERENCES_SUCCESS';
export const UPDATE_PREFERENCES_SUCCESS = 'UPDATE_PREFERENCES_SUCCESS';
export const LOAD_DEPARTURE_CALENDARS_SUCCESS = 'LOAD_DEPARTURE_CALENDARS_SUCCESS';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js